/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Answer_Feedback_Error_Not_AgentInputs */

const es_co2_answer_feedback_error_not_agent = /** @type {(inputs: Answer_Feedback_Error_Not_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se pueden valorar las respuestas de Standar.`)
};

/**

* @param {Answer_Feedback_Error_Not_AgentInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const answer_feedback_error_not_agent = /** @type {((inputs?: Answer_Feedback_Error_Not_AgentInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Answer_Feedback_Error_Not_AgentInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_answer_feedback_error_not_agent(inputs)
});